import { render, staticRenderFns } from "./assignees_list_item.vue?vue&type=template&id=bcbec8dc&"
import script from "./assignees_list_item.vue?vue&type=script&lang=js&"
export * from "./assignees_list_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "assignees_list_item.vue"
export default component.exports